// extracted by mini-css-extract-plugin
module.exports = {"mainview":"index-module--mainview--1x2Ei"};